import type React from 'react';
import './Button.scss';

export interface ButtonProps {
  children: React.ReactNode;
  /**
   * primary = blue fill, secondary = white with border, danger = destructive
   * text link, destructive = red fill for the confirming action in a dialog.
   */
  variant?: 'primary' | 'secondary' | 'danger' | 'destructive';
  size?: 'sm' | 'md';
  fullWidth?: boolean;
  disabled?: boolean;
  loading?: boolean;
  type?: 'button' | 'submit';
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  disabled = false,
  loading = false,
  type = 'button',
  onClick,
  className = '',
}) => {
  const classes = [
    'btn',
    `btn--${variant}`,
    `btn--${size}`,
    fullWidth && 'btn--full',
    loading && 'btn--loading',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button type={type} className={classes} disabled={disabled || loading} onClick={onClick}>
      {loading && <span className="btn__spinner" aria-hidden="true" />}
      <span className="btn__label">{children}</span>
    </button>
  );
};

export default Button;
